import React, { useState } from 'react';
import { FaUpload, FaTrash, FaEye } from 'react-icons/fa';
import { toast } from 'react-toastify';

import Tabela from '~/Components/TabelaDinamica/Tabela';
import ModalConfirmacao from '~/Components/ModalConfirmacao';
import AuthStorage from '~/Utils/AuthStorage';
import { caracteristicas } from '~/constant';
import {
  uploadAnexoQualidade,
  excluirAnexoQualidade,
  visualizarAnexoQualidade,
} from '~/Services/Service';

const MAX_SIZE_KB = 600;

const TabAnexarDoc = ({ ativos, onRecarregar }) => {
  const [showConfirm, setShowConfirm] = useState(false);
  const [ativoExcluir, setAtivoExcluir] = useState(null);
  const [showSubstituir, setShowSubstituir] = useState(false);
  const [pendingUpload, setPendingUpload] = useState(null);

  const temSupervisor = AuthStorage.temCaracteristica(
    caracteristicas.SupervisorGED
  );

  const handleUpload = (item) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.pdf,.jpg,.jpeg,.png,.doc,.docx';
    input.onchange = (e) => {
      const file = e.target.files[0];
      if (!file) return;

      const sizeKB = file.size / 1024;
      if (sizeKB > MAX_SIZE_KB && !temSupervisor) {
        toast.error(
          `Arquivo excede ${MAX_SIZE_KB}KB. Necessária permissão de Supervisor GED.`
        );
        return;
      }

      if (item.tem_anexo === 'S') {
        setPendingUpload({ item, file });
        setShowSubstituir(true);
      } else {
        executarUpload(item.codigo_ativo, file);
      }
    };
    input.click();
  };

  const confirmarSubstituicao = (confirmado) => {
    setShowSubstituir(false);
    if (confirmado && pendingUpload) {
      executarUpload(pendingUpload.item.codigo_ativo, pendingUpload.file);
    }
    setPendingUpload(null);
  };

  const executarUpload = async (codigoAtivo, file) => {
    const formData = new FormData();
    formData.append('file', file);
    try {
      await uploadAnexoQualidade(codigoAtivo, formData);
      toast.success('Documento anexado com sucesso');
      if (onRecarregar) onRecarregar();
    } catch (err) {
      const msg =
        (err.response && err.response.data && err.response.data.message) ||
        (err.response && err.response.data) ||
        'Erro ao anexar documento';
      toast.error(msg);
    }
  };

  const handleExcluir = (item) => {
    setAtivoExcluir(item);
    setShowConfirm(true);
  };

  const confirmarExclusao = async (confirmado) => {
    setShowConfirm(false);
    if (!confirmado) return;
    try {
      await excluirAnexoQualidade(ativoExcluir.codigo_ativo);
      toast.success('Anexo excluído com sucesso');
      if (onRecarregar) onRecarregar();
    } catch (err) {
      const msg =
        (err.response && err.response.data && err.response.data.message) ||
        (err.response && err.response.data) ||
        'Erro ao excluir anexo';
      toast.error(msg);
    }
  };

  const handleVisualizar = async (item) => {
    try {
      const res = await visualizarAnexoQualidade(item.codigo_ativo);
      const url = window.URL.createObjectURL(new Blob([res.data]));
      window.open(url, '_blank');
    } catch {
      toast.error('Erro ao visualizar anexo');
    }
  };

  const colunas = [
    { title: 'Código', key: 'codigo_ativo', width: '80px' },
    { title: 'Nome', key: 'nome' },
    { title: 'Quadra', key: 'quadra', width: '80px' },
    { title: 'Lote', key: 'lote', width: '80px' },
    {
      title: 'Tem Anexo',
      key: 'tem_anexo',
      width: '90px',
      render: (v) => (v === 'S' ? 'Sim' : 'Não'),
    },
  ];

  const acoes = [
    { label: 'Anexar', icon: <FaUpload />, onClick: handleUpload },
    {
      label: 'Visualizar',
      icon: <FaEye />,
      onClick: handleVisualizar,
    },
    {
      label: 'Excluir',
      icon: <FaTrash />,
      onClick: handleExcluir,
      type: 'danger',
    },
  ];

  return (
    <>
      <Tabela colunas={colunas} dados={ativos} acoes={acoes} action />

      <ModalConfirmacao
        show={showConfirm}
        onClose={confirmarExclusao}
        title="Excluir Anexo"
        message="Deseja realmente excluir o anexo deste ativo?"
      />

      <ModalConfirmacao
        show={showSubstituir}
        onClose={confirmarSubstituicao}
        title="Substituir Anexo"
        message="Este ativo já possui um anexo. Deseja substituí-lo?"
      />
    </>
  );
};

export default TabAnexarDoc;
